module.exports = __webpack_public_path__ + "static/media/1.e51d2118.JPG";